import actions from './actions'

export default function WorkOrderCustomerStatusesReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_WORKORDERCUSTOMERSTATUS:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_WORKORDERCUSTOMERSTATUS:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_WORKORDERCUSTOMERSTATUS:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_WORKORDERCUSTOMERSTATUS:
      return {
        ...state,
        editing: { workOrderCustomerStatusID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_WORKORDERCUSTOMERSTATUS_RECIEVED ||
      actions.UPDATE_WORKORDERCUSTOMERSTATUS_RECIEVED ||
      actions.DELETE_WORKORDERCUSTOMERSTATUS_RECIEVED:
      return {
        ...state,
        editing: { workOrderCustomerStatusID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
